import React, { useState, useEffect } from "react";
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import Style from './data/findDealerMapStyles';
import view from "./findDealer.module.scss";
import darkStyle from './findDealerMapStylesDark';
import darkView from "./darkDirections.module.scss";

const { siteMetadata } = require('../../../gatsby-config');
//const googleAPIkey = siteMetadata.googleAPIkey; //TODO: fix this in gatsby-config
const googleAPIkey = 'AIzaSyCddq6ehnmTvcAdFOvG5xEGhn8jZV3eBqY';

const FindDealerMap = (props) => {

    const dealerLocations = props.props.props.data.addtlLoc;
    const google = props.google;
    const mapStyles = Style;
    const darkMapMode = props.props.props.data.darkMapMode || true;
    const style = darkMapMode ? darkStyle : darkStyle;


    const [showingInfoWindow, setShowingInfoWindow] = useState(false);
    const [activeMarker, setActiveMarker] = useState({});
    const [selectedPlace, setSelectedPlace] = useState({});


    if (!props.loaded || !google) {
        return <div>Loading Map...</div>;
    }

    let bounds = null; 
    if (dealerLocations && dealerLocations.length > 0) {
        bounds = new google.maps.LatLngBounds();
        dealerLocations.forEach(location => {
            const lat = parseFloat(location.lat);
            const lng = parseFloat(location.lng);
            if (!isNaN(lat) && !isNaN(lng)) {
                bounds.extend(new google.maps.LatLng(lat, lng));
            }
        });
    }


    const defaultCenter = { lat: 39.8283, lng: -98.5795 }; // fallback
    const defaultZoom = 4;

    const onMarkerClick = (markerProps, marker, e) => {
        setSelectedPlace(markerProps);
        setActiveMarker(marker);
        setShowingInfoWindow(true);
    };

    const onInfoWindowClose = () => {
        setShowingInfoWindow(false);
        setActiveMarker(null);
    };

    const onMapClicked = (mapProps) => {
        if (showingInfoWindow) {
            setShowingInfoWindow(false);
            setActiveMarker(null);
        }
    };

    return (
        <div className={darkMapMode ? darkView["map"] : view["map"]}> {/* Ensure container has height opr map won't show */}
            <Map
                google={google}
              
                {...(bounds ? { bounds: bounds } : { initialCenter: defaultCenter, zoom: defaultZoom })}
              
                style={{ height: '100%', width: '100%', position: 'relative' }}
                containerStyle={{ height: '100%', width: '100%', position: 'relative' }}
                styles={mapStyles}
                mapTypeControl={false}
                streetViewControl={false}
           
                zoomControl={true}
                fullscreenControl={false}
                onClick={onMapClicked}
              
                onReady={(mapProps, map) => {
                  if (bounds) {
                     map.fitBounds(bounds, 50); //map padding
                  }
                }}
            >
                {dealerLocations.map((location, index) => (
                    <Marker
                        key={index}
                        name={location.name}
                        address={location.address}
                        phone={location.phone}
                        position={{
                            lat: parseFloat(location.lat),
                            lng: parseFloat(location.lng)
                        }}
                        hours={location.locHours}
                        onClick={onMarkerClick}
                        icon={{
                          path: "M0 -7 C-3.87 -7 -7 -3.87 -7 0 c0 4.25 7 13 7 13 s7 -8.75 7 -13 c0 -3.87 -3.13 -7 -7 -7z",
                          scale: 2,
                          fillColor: "#00665e", //pin color
                          fillOpacity: 1,
                          strokeWeight: 1,
                          strokeColor: "#00665e", //pin color
                        }}
                        label={{
                          text: String.fromCharCode(65+index),
                          color: "var(--primary-text)",
                          
                        }}
                    />
                ))}

                <InfoWindow
                    marker={activeMarker}
                    visible={showingInfoWindow}
                    onClose={onInfoWindowClose}
                >
                    <div style={{ padding: '5px', textAlign: 'center' }}>
                        <h3 style={{ margin: '0 0 5px 0' }}>{selectedPlace.name}</h3>
                        <p style={{ margin: '0 0 5px 0', fontSize: '14px' }}>{selectedPlace.address}</p>
                        {selectedPlace.hours ? selectedPlace.hours.map((day, index) => (
                           <p style={{paddingBottom: '.5em'}} key={index}>{day.day}: {day.time}</p>
                        )) : ''}
                        {selectedPlace.phone && (
                             <a className={view["map-marker"]} href={`tel:${selectedPlace.phone}`}>
                                Call Us
                             </a>
                        )}
                    </div>
                </InfoWindow>
            </Map>
        </div>
    );
}

export default GoogleApiWrapper({
    apiKey: googleAPIkey
})(FindDealerMap);